import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	progressBarAriaLabel: {
		defaultMessage: 'Progress Bar',
		id: 'common.components.progress-bar.aria-label',
		description: 'Aria label for the progress bar',
	},
});
